<ng-container *ngIf="label">
  <om-label *ngIf="label" [text]="label" [icon]="icon" [isRequired]="this.required"></om-label>
</ng-container>
<div class="flexrow-nowrap-start gap-2">
  <nz-range-picker
    class="w-3/5"
    [formControl]="this.control"
    [nzPlaceHolder]="this._placeholder"
    [nzMode]="this.mode"
    [nzAllowClear]="this.allowClear"
  ></nz-range-picker>
  <ng-container *ngIf="deletable">
    <span
      class="cursor-pointer mt-2"
      nz-icon
      nzType="close-circle"
      nzTheme="twotone"
      nzTwotoneColor="#d81111"
      nz-tooltip
      nzTooltipTitle="{{ 'SETTINGS.CALENDARS_SETTINGS.DELETE' | translate }}"
      style="font-size: 18px"
      (click)="_emitClose($event)"
    ></span>
  </ng-container>
</div>
<ng-container *ngIf="control.invalid && control.dirty">
  <div class="om-error-placeholder">
    <om-error [control]="control"></om-error>
  </div>
</ng-container>
